export default {
  ROOT: '/',
  LOGIN: '/login',
  LOGOUT: '/logout',
  DASHBOARD: '/dashboard',
  PAGES: '/pages',
  ARTICLES: '/articles',
  EMAILS: '/emails',
  COMPETITIONS: '/competitions',
  EVENTS: '/events',
  CAMPAIGNS: '/campaigns',
  BOOKS: '/books',
  CHAPTERS: '/chapters',
  SECTIONS: '/sections',
  SETTINGS: '/settings',
  SETTINGS_CIS: '/settings-cis',
  SETTINGS_STATS_ZONE: '/settings-stats-zone',
  SETTINGS_MEDAL_CEREMONY: '/settings-medal-ceremony',
  MY_ACCOUNT: '/my-account',
  APPEARANCE: '/appearance',
  SPONSORS: '/sponsors',
  LANGUAGES: '/languages',
  VOCABULARY: '/vocabulary',
  MINISITES: '/minisites',
  LOCATIONS: '/locations',
  EVENT_APPEARANCE: '/event-appearance',
  MEDIA_LIBRARY: '/media',
  LIBRARY: '/library',
  MENUS: '/menus',
  FORBIDDEN: '/forbidden',
  ATHLETES: '/athletes',
  WHERE_TO_WATCH: '/where-to-watch',
  CHANNELS: '/channels',
  SCHEDULES: '/schedules',
  VIDEO: '/videos',
  CONFIG_CIS: '/config-cis',
  COMPETITION_MODE: '/competition_mode',
  WORLD_ATHLETICS_PLUS: '/worldathletics-plus',
  WIN_MODULE: '/win-module',
};
